import BaseSelect from "./base-select";
import {ActionTypeEnum} from "../../base/training-literals";

class BranchSelect extends BaseSelect {
    modelName;

    constructor(props = {}) {
        super(props);
        this.actionType = ActionTypeEnum.BRANCH_SELECT;
        this.modelName = props.modelName || "";
    }

    init() {
        this.existingBranchId = "-1";
        this.startSelectHandlerId = wv.communicator.addEventListenerWithID(text_startModelSelectionForTimelineLoad, (itemArr) => {
            const operationType = parseInt(itemArr[0]);
            this.actionId = itemArr[1];
            this.userId = itemArr[2];
            this.mapIndex = parseInt(itemArr[3]);
            this.existingBranchId = itemArr[4];

            if (operationType !== SelectionActionApplyToType.Tree) {
                return;
            }

            this.startSelection(this.existingBranchId);
        });

        this.cancelSelectHandlerId = wv.communicator.addEventListenerWithID(text_cancelModelSelectionForTimelineLoad, () => {
            this.cancelSelection();
        });
    }

    get(props = {}) {
        return {
            type: this.actionType,
            modelName: props.modelName || this.modelName,
            timelineMap: props.timelineMap || this.timelineMap,
            duration: props.duration || this.until
        }
    }

    startSelection(existingBranchId) {
        clearAllFeaturesFromAllHandler();
        SelectionData.resetHighlight();
        changeSelectionAction(SelectionActionEnum.Highlight);
        SelectionData.changeResetOnOutsideClickState(false);
        MeshHierarchyViewFeatureManager.resetTreeViewSelection();
        ModelTreeControllerFor2D.deselectAllNodes();

        const modelTreeViewList = document.getElementsByClassName('modelTreeView');
        const selectorButtons = document.getElementsByClassName('modelTreeSelectorClass');
        const itemsToShow = [...modelTreeViewList, ...selectorButtons];
        for (let item of itemsToShow) {
            item.style.visibility = 'visible';
        }

        JSTreeManager.hideAllOtherTreeViews();
        this.change2dVisibility(false);
        JSTreeManager.showFeatureListTreeView('AvailableFileListViewSideNav', false);
        this.hideTreesExcept("treeViewData");

        if (existingBranchId !== "-1") {
            ModelTreeControllerFor2D.getMultiSelector().clearAll();
            ModelTreeControllerFor2D.onChangeCheckStatus(existingBranchId, true);
        }
    }

    sendDataOnSelection({item, enable}) {
        if (this.existingBranchId !== "-1" && this.existingBranchId !== item.id) {
            ModelTreeControllerFor2D.onChangeCheckStatus(this.existingBranchId, false);
        }

        const payload = {
            message: text_startModelSelectionForTimelineLoad.command,
            actionId: this.actionId,
            index: this.mapIndex,
            actionType: SelectionActionApplyToType.Tree,
            item,
            enable,
        };

        wv.communicator.socket.communicateWithContainer(payload);
        if (enable) {
            this.hideTreesExcept();
            this.change2dVisibility(true);
        }
    }

    cancelSelection() {
        this.hideTreesExcept();
        this.change2dVisibility(true);
        SelectionData.resetHighlight();
        ModelTreeControllerFor2D.deselectAllNodes();
    }

    change2dVisibility(visible) {
        ModelTreeControllerFor2D.showModelTree = !visible;
        JSTreeManager.showModelTreeView('modelTreeViewSideNav', ModelTreeControllerFor2D.showModelTree);
        let items = document.getElementById('modelTreeSelectorChildData');
        for (let childItem of items.childNodes) {
            if (!childItem.style) {
                continue;
            }

            if (visible || childItem.id === 'FindInTree2D') {
                childItem.style.display = 'block';
            } else {
                childItem.style.display = 'none';
            }
        }
    }

    cancel() {
        this.cancelSelection();
        this.startSelectHandlerId && wv.communicator.removeEventListenerWithID(this.startSelectHandlerId);
        this.cancelSelectHandlerId && wv.communicator.removeEventListenerWithID(this.cancelSelectHandlerId);
        this.startSelectHandlerId = this.cancelSelectHandlerId = null;
    }
}

export default BranchSelect;
